export function hzToMidi(hz) {
    return 69 + 12 * Math.log2(hz / 440);
}
export function midiToHz(midi) {
    return 440 * Math.pow(2, (midi - 69) / 12);
}
export function pitchCloseness(pitchHz, targetHz, opts = {}) {
    if (!(pitchHz > 0) || !(targetHz > 0))
        return 0;
    const tol = opts.toleranceSemitones ?? 0.5;
    let dSemis;
    if (opts.octaveTolerant) {
        const pcA = ((hzToMidi(pitchHz) % 12) + 12) % 12;
        const pcB = ((hzToMidi(targetHz) % 12) + 12) % 12;
        let d = Math.abs(pcA - pcB);
        if (d > 6)
            d = 12 - d;
        dSemis = d;
        if (dSemis <= tol)
            return 1;
        const rawFalloff = opts.falloffSemitones ?? 2;
        const maxSpan = Math.max(1e-6, 6 - tol);
        const falloff = Math.min(rawFalloff, maxSpan);
        const v = 1 - (dSemis - tol) / falloff;
        return v < 0 ? 0 : v > 1 ? 1 : v;
    }
    else {
        dSemis = Math.abs(hzToMidi(pitchHz) - hzToMidi(targetHz));
    }
    if (dSemis <= tol)
        return 1;
    const falloff = opts.falloffSemitones ?? 2;
    const v = 1 - (dSemis - tol) / falloff;
    return v < 0 ? 0 : v > 1 ? 1 : v;
}
